import { combineReducers } from 'redux';

import { signalConstants } from '../constants';

export interface ListSignalsState {
  loading?: boolean;
  signals?: any[];
  error?: Error;
}
const listSignals = (
  state: ListSignalsState = { signals: [] },
  action
): ListSignalsState => {
  switch (action.type) {
    case signalConstants.GET_ALL_REQUEST: {
      return {
        loading: true,
      };
    }
    case signalConstants.GET_ALL_SUCCESS: {
      return {
        signals: action.signals,
      };
    }
    case signalConstants.GET_ALL_FAILURE: {
      return {
        error: action.error,
      };
    }

    default: {
      return state;
    }
  }
};

export default combineReducers({
  listSignals,
});
